import React from 'react'
import { twMerge } from 'tailwind-merge'
import { useTranslation } from 'react-i18next'
import { OptionsInterface } from './types'
import {
  OptionWrapper,
  OptionWrapperProps,
} from 'src/editor/layout/sidebar/settings/option-wrapper'

export interface SwitcherProps<T> extends OptionWrapperProps {
  className?: string
  btnClassName?: string
  wrapperClassName?: string
  btnList: OptionsInterface<T>[]
  value: T
  update: (value: T) => void
}

export const Switcher = <T extends number | string | boolean>({
  className,
  btnClassName,
  wrapperClassName,
  btnList,
  update,
  value,
  ...props
}: SwitcherProps<T>) => {
  const { t } = useTranslation()

  const handleButtonClick = (value: T) => {
    update(value)
  }
  return (
    <OptionWrapper {...props} className={wrapperClassName}>
      <div
        className={twMerge(
          'flex w-full rounded-md border border-border200 p-1',
          className,
        )}
      >
        {btnList.map(btn => (
          <button
            type="button"
            className={twMerge(
              'min-h-9 w-full cursor-pointer rounded-md text-M text-textSecondary transition hover:text-textPrimary',
              btn.value === value && 'bg-bgSecondary text-textPrimary',
              btnClassName,
            )}
            key={btn.value.toString()}
            onClick={() => handleButtonClick(btn.value)}
          >
            {typeof btn.content === 'string' ? t(btn.content) : btn.content}
          </button>
        ))}
      </div>
    </OptionWrapper>
  )
}
